import React from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import FlexRow from '../../molecules/FlexRow'
import Tooltip from '../../atoms/Tooltip'
import Icon from '../../atoms/Icon'
import { useTabGroup } from './tabContext'

const variantStyles = (theme) => ({
  primary: {
    selected: {
      fontWeight: theme.typography.weights.bold,
      backgroundColor: 'var(--color-primary-500)',
      color: 'var(--color-contrast-primary-500)',
      fill: 'var(--color-contrast-primary-500)',
      stroke: 'var(--color-contrast-primary-500)'
    },
    unselected: {
      fontWeight: theme.typography.weights.light
    }
  },
  secondary: {
    selected: {
      opacity: 1
    },
    unselected: {
      opacity: 0.35,
      color: 'var(--color-primary-500)'
    }
  }
})

const useStyles = makeStyles((theme) => ({
  sydIconTabItem: ({ variant }) => ({
    userSelect: 'none',
    padding: 'var(--padding-sm) var(--padding-sm) var(--padding-xs) var(--padding-sm)',
    borderRadius: 'var(--border-radius-md)',
    transition: 'background-color var(--transition-duration-short) ease-in-out',
    ...variantStyles(theme)[variant]?.unselected,
    '&.__selected': variantStyles(theme)[variant]?.selected
  }),
  sydIconTabList: {
  }
}))

function SydIconTabList ({ size, variant = 'primary' }) {
  const classes = useStyles(({ variant }))
  const { selectedValue, selectValue, options } = useTabGroup()

  return (
    <FlexRow>
      {options.map((o) => (
        <div key={o.value} className='flex flex-row items-center gap-xs'>
          <Tooltip title={o?.payload?.label || o?.payload}>
            <div
              role='button'
              className={clsx(classes.sydIconTabItem, { __selected: selectedValue === o.value })}
              onClick={() => selectValue(o.value)}
            >
              <Icon name={o.payload.icon} customSize={size} />
            </div>
          </Tooltip>
        </div>
      ))}
    </FlexRow>
  )
}

SydIconTabList.propTypes = {
  size: PropTypes.number,
  variant: PropTypes.oneOf(['primary', 'secondary'])
}

export default SydIconTabList
